import { defineMessages } from 'react-intl';

export default defineMessages({
    thisFieldMustBeUnique: {
        id: 'CPMIpolicycommon.directives.schedules.dataItem.This field must be unique',
        defaultMessage: 'This field must be unique'
    },
    requiredField: {
        id: 'CPMIpolicycommon.directives.schedules.dataItem.This is a required field',
        defaultMessage: 'This is a required field'
    },
    ownerShipSelectedValue: {
        id: 'CPMIpolicycommon.directives.schedules.dataItem.Please enter value between 0 and 100',
        defaultMessage: 'Please enter value between 0 and 100'
    }
});
